export default "__VITE_ASSET__D0NmqiHm__"